<template>
  <div>
    <div id="cont" class="container">
      <div class="row">
        <div class="col-12">
          <b-nav
              id="nav">
            <a href="#/">
            <b-img
                :src="logoImg"
                alt="Emu"
                id="logo"></b-img>
            </a>
            <a href="#/assist">
              <b-img
                  :src="assistImg"
                  alt="Assist"
                  id="assist"
              ></b-img>
            </a>
            <a href="#/assist">
              <h4 id="assist_label">智能助手</h4>
            </a>
            <div class="ml-auto" id="breadcrumb">
              <small class="bc-divider">当前位置：</small>
              <a class="bc-divider" href="#/">首页</a>
              <small class="bc-divider"> > </small>
              <a class="bc-active">文章</a>
            </div>
          </b-nav>
        </div>
      </div>
      <div class="row">
        <div id="sidebar" class="col-md-4">
          <side-bar></side-bar>
        </div>
        <div id="content" class="col-md-8">
          <h5 id="title">韩国现“夺命疫苗” 36人接种后死亡，相关性未确认</h5>
          <p id="subtitle">2020年10月23日 21:13 来源：时代财经</p>
          <b-img id="image" center :src="banner3Img"></b-img>
          <div id="article">
            <p>据韩国疾病管理厅的数据，直至北京时间今日中午12时，韩国已有36人在流感疫苗接种后死亡。</p>
            <p>目前还无法证明这些死亡病例与流感疫苗接种有直接关系，韩国政府也决定继续疫苗接种计划。甚至为了平息公众疑虑，韩国国务总理丁世均特地前往接种。</p>
            <p>但因至今无法确定相关性，再加上10月初当地流感疫苗被爆出“暴露在常温下”、“有白色悬浮物”等问题，韩国舆论仍然陷入了恐慌，并持续发酵。23日，不少韩国地方医院决定中断疫苗接种。</p>
            <p>国务总理丁世均也于23日上午，就流感疫苗接种后死亡病例接连出现一事，要求防疫当局彻底调查。</p>
            <p>时代财经10月22日致电韩国疾病管理厅，对方未就相关问题予以回答。直至发稿时，对方也未回复采访邮件。</p>
            <p>中国多位疫苗专家均向时代财经表示，目前疫苗安全性非常高，如果仅仅由于死者在几天前曾经接种，便断定二者具有因果性，恐怕过于轻率。</p>
            <p>此外，中国疾病预防控制中心在2019年的一份统计显示，中国每年平均有近9万人死于流感相关疾病，但流感疫苗的人口覆盖率仅约2%。</p>
            <p>与疫苗安全性相比，流感的危险性恐怕更值得关注。</p>
            <p>据韩国媒体报道，仁川一名17岁男子于10月14日接种了流感疫苗，却在两天后死亡。此后，韩国各地陆续出现多起类似死亡病例，且增长速度越来越快，仅10月22日一天就报告了20起。</p>
            <p>这些死亡病例中，绝大部分均为老年人。据韩国疾病管理厅22日数据显示，在当日统计的25件病例中，9人为80岁以上，12人在70～80岁，1人在60～70岁，只有三人为60岁以下。</p>
            <p>接二连三出现接种疫苗后死亡的报告，引起了韩国民众对疫苗安全性的质疑。韩国一所医院在21日对媒体称，前来接种流感疫苗的市民比前一天少了六成，医院还接到多个确认疫苗是否安全的咨询电话。</p>
            <p>为了平息疑虑，韩国国务总理丁世均21日前往世宗市的保健所接种了疫苗。而据《中央日报》22日消息，保健福祉部长官朴凌厚也将于26日接种，目前正在等待中。</p>
            <p>10月22日，韩国疾病管理厅厅长郑银敬在对国会报告时表示，死者接种的疫苗由5家公司生产，批号都不一样，所以并不是某家公司或者某批次的疫苗出现了问题。</p>
            <p>郑银敬还称，专家组通过电话，对跟死者同一天在同一医疗机关接种疫苗的人进行了调查，都没有出现重症异常反应。专家组认为，不是因疫苗问题致死。</p>
            <p>但随着相关死亡报告数的上升，民众的疑虑及恐慌并未消除。今日，当地不少地方医院决定中断接种。</p>
            <p>今日下午，韩国疾病管理厅再次表示，“流感疫苗与死亡病例相关性尚未得到确认，继续接种。”</p>
            <p>截至目前，韩国已有接近1300万人，也就是约四分之一人口，接种了流感疫苗。</p>
            <p>时代财经查阅韩国疾病管理厅官方数据，发现在目前已完成调查的9起病例中，死亡时间距离接种最短的是12小时，最长的是51小时。</p>
            <p>自媒体《疫苗与科学》运营者、疫苗专家陶黎纳向时代财经介绍，疫苗致死，除了急性过敏反应，其他情况几乎是不可能的，而急性过敏反应会在接种后30分钟内出现。</p>
            <p>陶黎纳向时代财经分析，韩国“疫苗致死事件”可能是群众恐慌下渲染的产物。“目前根本没有证据证明死因与疫苗有关，只是因为接种后几天发生了，就胡乱扯上关系。如果媒体要挖掘或是发动公众去联想，至少可以找到不下100个接种流感疫苗后3天内死亡的老年人案例。”</p>
            <p>韩国保健福祉部长官朴凌厚在22日的国会上也称，“去年韩国有20万4000名70岁以上的老人死亡，估计其中有一半注射过疫苗。”</p>
            <p>韩国的免费流感疫苗计划，可谓是波折不断。</p>
            <p>该计划的初衷，是为了防止同时出现流感和新冠大流行的局面。韩国计划从9月22日开始，面向1900万人推出免费接种流感疫苗。根据该计划，韩国出生6个月到18岁以下的少年儿童、孕妇以及年满62岁的老人，均可以免费接种流感疫苗，涵盖人群达全国近四成。</p>
            <p>然而9月22日当天，针对青少年的免费流感疫苗接种被紧急叫停。</p>
            <p>韩国疾病管理厅厅长郑银敬解释，疫苗从生产到接种都要保持冷藏状态，但部分企业在运输疫苗的过程中违反了这一规定，冷冻库失效，疫苗暴露在常温之下。据悉，这批涉事疫苗有539万剂，原计划将提供给青少年接种。</p>
            <p>尽管郑银敬强调，这些疫苗只是在运输过程中保存温度不当，疫苗生产过程不存在问题，但此事无疑让部分民众对疫苗安全性种下疑虑。</p>
            <p>不久，流感疫苗被再次爆出问题。10月6日，韩国多家媒体报道，韩国疫苗公司（Korea Vaccine）所生产的流感疫苗被发现含有白色悬浮物。</p>
            <p>韩国食品医药品安全厅在调查后称，白色悬浮物为无害的蛋白质，已于9日紧急回收了61万剂疫苗。但据韩媒报道称，已有超过17000人接种了该疫苗。</p>
            <p>据悉，此次接种疫苗来源多样，生产商包括韩国绿十字、SK生物科学、保宁制药、LG化学等韩国企业，还有一家国外厂商——法国赛诺菲巴斯德公司。此外，葛兰素史克虽没有参与该计划，但也为韩国付费流感疫苗的生厂商之一。</p>
            <p>葛兰素史克媒体关系主任Madeleine Breckon接受时代财经采访时称，“经确认，公司在韩国的流感疫苗既没有质量问题，也没有冷链问题。”</p>
            <p>陶黎纳回忆，疫苗恐慌也曾在中国出现过。</p>
            <p> 2013年年底，乙肝疫苗接种曾被广泛质疑，陆续出现所谓“疫苗异常反应致死”的案例。2014年初，中国疾控中心表示，对10个省份的调查发现，近一个月乙肝疫苗接种率下滑了近三成。</p>
            <p>之后，国家食药总局、国家卫生计生委联合通报：累计报告的17例疑似与接种乙肝疫苗有关的死亡病例，均明确或初步判断与接种疫苗无关。</p>
            <p>根据中国疾控中心的数据，2000年至2013年，13年间接种乙肝疫苗后死亡的疑似异常反应病例已上报188例，其中，最终确定为疫苗异常反应的仅为18例。</p>
            <p>流感疫苗方面，据中国疾病预防控制中心2019年的统计，中国的流感疫苗人口覆盖率很低，仅约2%；而中国每年平均有88100例与流感相关额外的呼吸系统疾病死亡，相当于所有呼吸系统疾病死亡的8.2%。</p>
            <p>复旦大学生命科学学院教授林金钟向时代财经表示，近年来，随着药监局监管制度越来越完善，中国疫苗的安全度也越来越高。“民众有一定疑虑可以理解，但没必要上升到恐慌的程度。我自己的孩子也接种了流感疫苗。”</p>
            <p>广州市越秀区某社区医院医生告诉时代财经，目前流感疫苗接种，均由社区医院负责，大医院不会“杀鸡用牛刀”。</p>
            <p>据悉，社区医院的接种门诊，有设置标准，要求配备冰箱、建立测温制度。接种疫苗会有专人管理，每一支疫苗都会进行登记，疫苗名称、批号、领取人等都会记录在案，以便跟踪。疫苗的运输、保存和使用，都会严格按照有关的温度要求进行。</p>

            <div id="cover">
              <p
                  id="expandText"
                  class="expand">
                点击展开全文
              </p>
              <b-img
                  id="expandImg"
                  class="expand"
                  :src="blueArrowImg">
              </b-img>
            </div>
          </div>
          <a
              href="#/"
              class="pageLink">
            下一篇：17岁前接种HPV疫苗患宫颈癌风险降低88%
          </a>
          <a
              href="#/"
              class="pageLink">
            上一篇：世卫组织表示：健康的年轻人可能需延后使用新冠疫苗！
          </a>
          <br>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import common from "../common";
import SideBar from "@/components/SideBar";

export default {
  name: "Article",
  components: {SideBar},
  data() {
    return {
      logoImg: common.logoImgSrc,
      blueArrowImg: common.blueArrowImgSrc,
      banner1Img: common.banner1ImgSrc,
      banner3Img: common.banner3ImgSrc,
      assistImg: common.assistImgSrc,
    }
  },
  mounted() {
    for (let i of document.querySelectorAll(".expand")) {
      i.onclick = () => {
        document.querySelector("#article").style.height = "auto"
        document.querySelector("#cover").style.visibility = "hidden"
      }
    }
  }
}
</script>

<style>
body {
  background: #f5f5f5 !important;
}
</style>

<style scoped src="../main.css"/>

<style scoped>
#title {
  text-align: center;
  margin-top: 5vh;
  font-weight: bold;
}

#subtitle {
  text-align: center;
  color: grey;
}

#image {
  border-radius: 1.5vw;
  overflow: hidden;
  width: 90%;
}

#article {
  margin-top: 3vh;
  margin-left: 5%;
  margin-bottom: 3vh;
  width: 90%;
  overflow: hidden;
  height: 300px;
  position: relative;
  font-size: large;
}

#cover {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 85px;
  background-color: rgba(0.5, 0.5, 0.5, 0);
  -webkit-backdrop-filter: blur(6px);
  backdrop-filter: blur(6px);
}

#expandImg {
  height: 20px;
}

#expandText {
  display: inline-block;
  color: steelblue;
  line-height: 85px;
  margin-left: 40%;
}

.pageLink {
  display: block;
  margin-bottom: 1vh;
  margin-left: 3vw;
  color:  steelblue;
}
</style>
